<router-outlet></router-outlet>
<app-pdf-viewer></app-pdf-viewer>
@let err = error();
<nz-modal [nzVisible]="!!err" [nzTitle]="errTitle" (nzOnCancel)="error.set(null)">
  <ng-template #errTitle>
    {{ err?.errorType }}
  </ng-template>
  <ng-container *nzModalContent>
    @if (err) {
      @let e = err.error;
      @let t = err.errorType;
      @switch (t) {
        @case ('HttpErrorResponse') {
          <div>{{ e.message }}</div>
          <div><small>{{ e.error.detail }}</small></div>
        }
        @case ('GraphQLError') {
          <div>{{ e.message }}</div>
          <div><small>{{ e.error.detail }}</small></div>
        }
        @case ('TypeError') {
          <div>{{ e.message }}</div>
          <div><small>{{ e.error.detail }}</small></div>
        }
        @default {
          <div>{{ e.message }}</div>
        }
      }
    }
  </ng-container>
  <div *nzModalFooter>
    <button nz-button nzType="default" (click)="error.set(null)">Close</button>
  </div>
</nz-modal>
